import React from 'react';

import ReactSelect, { Props, components } from 'react-select';

import './Select.css';
import { useTranslation } from 'react-i18next';

export const Select = React.forwardRef<any, Props>(
	(
		{ className = '', classNamePrefix = 'select', ...props }: Props,
		ref: any
	) => {
		const { t } = useTranslation('labels');

		// Same as default option but with support for title. Label by default
		const Option = (props: any) => {
			return (
				<div style={props.styles} title={props.title ?? props.label}>
					<components.Option {...props} />
				</div>
			);
		};

		return (
			<ReactSelect
				ref={ref}
				className={`select ${className}`}
				classNamePrefix={classNamePrefix}
				components={{ Option }}
				placeholder={t('labels:select_options')}
				noOptionsMessage={() => t('labels:no_options')}
				{...props}
			/>
		);
	}
);

Select.displayName = 'Select';
